import React from "react";
import { useTranslation } from "react-i18next";

interface GenerationItemProps {
    apiName: string;
    label: any;
    doneEnhancements: string;
    loadingItem: boolean;
    isApplying: boolean;
    onClick: (apiName: string) => void;
    svg: React.ReactNode;
    allowReapply?: boolean;
    disableAll?: boolean;
    hideItem?: boolean;
}

const GenerationItem: React.FC<GenerationItemProps> = ({
    apiName,
    label,
    doneEnhancements,
    loadingItem,
    isApplying,
    onClick,
    svg,
    allowReapply,
    disableAll,
    hideItem 
}) => {

    const { t } = useTranslation();
    const isDisabled = isApplying || disableAll;

    
    if (hideItem) {
        return null;
    }

    return (

        <li className={`mb-3 back-color-home back-F1F5F9 border-E6E6E6 ${doneEnhancements == "Apply" ? "" : "back-done"} ${(label.name == "Generate QR Code" || label.name == "Room Image Generation") ? "cursor-p" : ""}`} onClick={() => { if (label.name == "Generate QR Code" || label.name == "Room Image Generation") { onClick(apiName) } }} >
            <div className="d-flex align-items-center">
                {svg}
                <h5 className="para-16 color-black bold-500">{label.name}</h5>
                {label.popUp && <svg width="16" height="16" className="marg-left-10" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M7.33349 1.33337H4.00016C2.5275 1.33337 1.3335 2.52737 1.3335 4.00004V12C1.3335 13.4727 2.5275 14.6667 4.00016 14.6667H12.0002C13.4728 14.6667 14.6668 13.4727 14.6668 12C14.6668 10.486 14.6668 8.66671 14.6668 8.66671C14.6668 8.29871 14.3682 8.00004 14.0002 8.00004C13.6322 8.00004 13.3335 8.29871 13.3335 8.66671V12C13.3335 12.736 12.7362 13.3334 12.0002 13.3334C9.78016 13.3334 6.21949 13.3334 4.00016 13.3334C3.2635 13.3334 2.66683 12.736 2.66683 12C2.66683 9.78004 2.66683 6.21937 2.66683 4.00004C2.66683 3.26337 3.2635 2.66671 4.00016 2.66671H7.33349C7.70149 2.66671 8.00016 2.36804 8.00016 2.00004C8.00016 1.63204 7.70149 1.33337 7.33349 1.33337ZM12.3908 2.66671H10.0002C9.63216 2.66671 9.33349 2.36804 9.33349 2.00004C9.33349 1.63204 9.63216 1.33337 10.0002 1.33337H14.0002C14.3682 1.33337 14.6668 1.63204 14.6668 2.00004V6.00004C14.6668 6.36804 14.3682 6.66671 14.0002 6.66671C13.6322 6.66671 13.3335 6.36804 13.3335 6.00004V3.60937L8.47149 8.47137C8.21149 8.73137 7.78883 8.73137 7.52883 8.47137C7.26816 8.21137 7.26816 7.78871 7.52883 7.52871L12.3908 2.66671Z" fill="black" />
                </svg>}
            </div>

            {label.name !== "Generate QR Code" && label.name !== "Room Image Generation" && <div className="d-flex align-items-center text-align-right">
                {doneEnhancements == "Apply" ? (
                    <button
                        className={`badge bg-label-6366F1 border-trans cursor-p ${isDisabled ? "disabled" : ""}`}
                        onClick={() => onClick(apiName)}
                    >
                        {t("enhancementList.Apply")}
                    </button>
                ) : allowReapply && (
                    <button
                        className={`badge bg-label-success border-trans cursor-p ${isDisabled ? "disabled" : ""}`}
                        onClick={() => onClick(apiName)}
                    >
                        Re-Apply
                    </button>
                )}

                {loadingItem && (
                    <div className="col-auto marg-left-5">
                        <div className="spinner-border text-primary size-20" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}
            </div>}
        </li>

    );
};

export default GenerationItem;
